// extracted by mini-css-extract-plugin
module.exports = {"box":"Box-module__box___2sAM3","primary":"Box-module__primary___wznPU"};